module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/aaatenBC.9786c32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/aaatenBC.jpg
// module id = Sj9z
// module chunks = 0